import { useMemo } from 'react';
import { createdAtDateTimeSortDesc } from 'helpers/sort';
import { toInspectionOnTableView } from 'presentation/inspection/inspectionModelToInspectionOnView';
import { InspectionOnTableView } from 'presentation/inspection/inspectionOnView';
import { useFilteredInspections } from './useFilteredInspections';
import { useInspectionReferences } from './useInspectionReferences';
import { useInspectionTemplatesObject } from './useInspectionTemplatesObject';

export interface UseInspectionDataGridRowsResult {
  rows: InspectionOnTableView[];
  loading: boolean;
}

export function useInspectionDataGridRows(): UseInspectionDataGridRowsResult {
  const references = useInspectionReferences();
  const { templates, loading: templatesLoading } = useInspectionTemplatesObject();
  const { inspections, loading: inspectionsLoading } = useFilteredInspections();

  const rows = useMemo(
    () =>
      inspections
        .filter((inspection) => templates[inspection.template] !== undefined)
        .map((inspection) =>
          toInspectionOnTableView(
            references.processes,
            templates,
            inspection,
            references.sites,
            references.levels,
            references.workTypes,
            references.companies,
            references.contracts,
            references.organizationId
          )
        )
        .sort(createdAtDateTimeSortDesc),
    [inspections, templates, references]
  );

  return {
    rows,
    loading: templatesLoading || inspectionsLoading,
  };
}
